import {
  all,
  call,
  put,
  select,
  take,
  takeLatest,
  throttle,
} from 'redux-saga/effects'
import { callFetch } from '../../actions/fetch'
import { fireToastError } from '../../actions/toasts/fireToast'
import fireToastWarning from '../../actions/toasts/fireToastWarning'
import { IUserAccepted } from '../../actions/userAccount/user/fetchUser'
import {
  ILanguageSwitched,
  ISwitchLanguage,
  languageChanged,
  switchLanguage as changeLanguage,
} from '../../actions/userAccount/user/switchLanguage'
import {
  countryDictionaryAccepted,
  ICountryDictionaryUpdate,
  requestCountryDictionaryChange,
} from '../../actions/userObject/settings/countryDictionary'
import {
  objectTypeAccepted,
  requestObjectTypeChange,
} from '../../actions/userObject/settings/objectTypes'
import { localStorage } from '../../database'
import i18n, { Language } from '../../i18n'
import { CountryCode } from '../../i18n/countryCodes'
import { switchDateLanguage } from '../../i18n/dates'
import { fetchCountry } from '../../models/Country'
import { fetchObjectType } from '../../models/ObjectType'
import updateUser from '../../models/User/updateUser'
import { UserAccountActions } from '../../reducers/userAccount/actionNames'
import { getSelectedLanguage } from '../../reducers/userAccount/selectors/userLanguage'
import { CountryDictionary } from '../../reducers/userObject/actionNames'
import { ActionNames } from '../../utils/FetchActionsName'
import fetchActionsName from '../../utils/FetchActionsName/fetchActionsName'

function* loadLanguage() {
  const language = yield select(getSelectedLanguage)
  yield put(changeLanguage(language as CountryCode))
}

function saveCurrent(action: IUserAccepted) {
  const language = action.user.savedLanguage
  if (null === language || undefined === language) {
    return
  }

  localStorage.Driver.setItem(
    localStorage.Names.UserAccountStorage.SelectedLanguage,
    language,
  )
}

function* switchLanguage(action: ISwitchLanguage) {
  try {
    const actionNames = fetchActionsName(ActionNames.UpdateLanguage)
    const [{ service }] = yield all([
      take(actionNames.output),
      put(callFetch(actionNames.input, actionNames.output, updateUser)),
    ])

    if (action.reload !== false) {
      yield call(service, {
        savedLang: action.language,
      })

      yield all([
        put(languageChanged(action.language, action.reload)),
        put(requestCountryDictionaryChange(action.language)),
        put(requestObjectTypeChange(action.language)),
      ])
    }

    yield all([put(languageChanged(action.language, action.reload))])
  } catch (e) {
    console.error(e)
    yield put(fireToastWarning(i18n.t('errStatus_11')))
  }
}

function* toggleUiLanguage(action: ILanguageSwitched) {
  try {
    const params = new URLSearchParams(window.location.search)

    if (params.get('disable_translate') || params.get('override_language')) {
      // ;(window as any).i18n = i18n
      // yield call(Language.load as any, 'none')

      console.log('disable translate')

      if (params.get('override_language')) {
        yield call(Language.load, params.get('override_language') as any)
      }

      yield call(
        Language.change as any,
        params.get('override_language') || 'none',
      )
      // console.log('disable translate')

      // yield switchDateLanguage(action.language)
    } else {
      yield call(Language.load, action.language)
      yield call(Language.change, action.language)
      yield switchDateLanguage(action.language)
    }

    localStorage.Driver.setItem(
      localStorage.Names.UserAccountStorage.SelectedLanguage,
      action.language,
    )
  } catch (e) {
    console.error(e)
    yield put(fireToastWarning(i18n.t('errStatus_11')))
  }
}

function* updateCountryAndObjectType(action: ICountryDictionaryUpdate) {
  try {
    const countryNames = fetchActionsName(ActionNames.FetchCountries)
    const objectNames = fetchActionsName(ActionNames.FetchObject)
    const [countryService, objectService] = yield all([
      take(countryNames.output),
      take(objectNames.output),
      put(callFetch(countryNames.input, countryNames.output, fetchCountry)),
      put(callFetch(objectNames.input, objectNames.output, fetchObjectType)),
    ])

    const [countries, objectTypes] = yield all([
      call(countryService.service, action.lang),
      call(objectService.service, action.lang),
    ])

    yield put(countryDictionaryAccepted(countries))
    yield put(objectTypeAccepted(objectTypes))
  } catch (e) {
    console.error(e)
    yield put(fireToastError(i18n.t('error_server_response_2')))
  }
}

export default function*() {
  yield takeLatest(UserAccountActions.UserDataAccepted, loadLanguage)

  yield takeLatest(UserAccountActions.UserDataAccepted, saveCurrent)
  yield throttle(2000, UserAccountActions.SwitchLanguage, switchLanguage)

  yield throttle(2000, UserAccountActions.LanguageSwitched, toggleUiLanguage)
  yield takeLatest(CountryDictionary.RequestUpdate, updateCountryAndObjectType)
}
